import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import OTPinput from 'Components/OTPinput/OTPinput';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import api from 'http';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import { LuKeyRound } from "react-icons/lu";
import { useDispatch } from 'react-redux';
import { signin } from 'Redux/UserAuthSlice/UserAuthSlice';
import Card from 'Components/UIComponents/Card/Card';
const OTPVerificationPopup = ({ onClose, disableDraggable, data, transferVia, enableMFA }) => {
    const uniqueId = "PatientProfilePicPopup"
    const [error, setError] = useState('');
    const [otp, setOtp] = useState('');
    const [resetOtp, setResetOtp] = useState(false); // State to reset OTP input
    const [loader, setLoader] = useState(false)
    const [showQr, setShowQr] = useState("")
    const [encryptedKey, setEncryptedKey] = useState("")

    const dispatch = useDispatch();

    const getOtp = (otp) => {
        setOtp(otp)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (otp === "") {
            setError('Please enter all digits');
            return;
        }
        try {
            setLoader(true)
            const payload = {
                "otp": otp,
                "encryptedKey": encryptedKey || "",
                "transferVia": transferVia,
                "isTwoFactorEnable": enableMFA,
            }
            let endPoint = null
            if (data.transferVia === "authenticator") {
                endPoint = "VerifyGoogleAuthenticatorCode"
            } else {
                endPoint = "VerifyOTP"
            }
            const response = await api.post(`${process.env.REACT_APP_TC_AUTH}/api/TwoFactorAuthentication/${endPoint}`, payload);
            dispatch(signin({
                twoFactorRequired: response.data.dataModel.twoFactorRequired,
                twoFactorViaAuthenticator: response.data.dataModel.twoFactorViaAuthenticator,
                twoFactorViaEmail: response.data.dataModel.twoFactorViaEmail,
                twoFactorViaText: response.data.dataModel.twoFactorViaText,
            }));
            onClose()
            // setShowQr({ status: false, qrImage: null })
            toast.success(response.data.responseMessage)
        } catch (error) {
            ErrorHandlingMessage(error)
            setResetOtp((prev) => !prev);
        } finally {
            setLoader(false)
        }
    }


    useEffect(() => {
        (async () => {
            if (enableMFA === false && transferVia === "authenticator") return
            try {
                setLoader(true)
                const payload = {
                    "isTwoFactorEnabled": enableMFA,
                    "encryptedPassword": "",
                    "twoFAEnabledVia": transferVia
                }
                const response = await api.post(`${process.env.REACT_APP_TC_AUTH}/api/TwoFactorAuthentication/ToggleTwoFactorAuthentication`, payload);
                if (enableMFA && transferVia === "authenticator") {
                    setShowQr(response.data.responseMessage)

                } else {
                    setEncryptedKey(response.data.dataModel[0])
                    toast.success(response.data.responseMessage)
                }
            } catch (error) {
                ErrorHandlingMessage(error)
            } finally {
                setLoader(false)
            }
        })();
    }, [enableMFA, transferVia])
    return (
        <ReactPortal wrapperId={uniqueId}>
            {/* {loading && <FullPageLoader allowFullScreen />} */}
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-full  min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            OTP Verification
                            <button onClick={() => onClose(false)} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>
                        <div className="p-5 overflow-y-auto ">
                            <div className='grid grid-cols-12 gap-4'>
                                <div className='col-span-12 '>
                                    {/* <img src={newImage} className='rounded-lg max-h-96 ' alt="patientpic" /> */}
                                    <div className="text-center">
                                        <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100">
                                            <LuKeyRound size={32} className='text-primary2' />
                                        </div>
                                        <h2 className="text-2xl font-semibold text-neutral-900">Two-Factor Authentication</h2>
                                        <p className="mt-2 text-center w-96 text-neutral-600">
                                            {data.transferVia === "authenticator" ? "Please enter the 6-digit verification code from your Google Authenticator app below." :
                                                data.transferVia === "email" ? "We've sent a verification code to your email address. Please enter it below." : "We've sent a verification code to your phone number. Please enter it below."}
                                        </p>
                                    </div>
                                    {
                                        showQr && (<img className='mx-auto size-48' src={showQr} alt="qrImage" />)
                                    }
                                    <form onSubmit={handleSubmit} >
                                        <OTPinput onComplete={getOtp} reset={resetOtp} />
                                        {error && (
                                            <p className="my-3 text-sm text-center text-red-600">{error}</p>
                                        )}

                                        <CustomButtonNew
                                            type="submit"
                                            fullWidth
                                            label="Verify Code"
                                            variant="filled"
                                            color="primary"
                                            loading={loader}
                                        />


                                    </form>
                                </div>

                            </div>
                        </div>


                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default OTPVerificationPopup